import {
  TextButton as TextButtonBase,
  type TextButtonProps as TextButtonBaseProps,
} from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

import { ButtonInternalLink } from "./ButtonInternalLink";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { TEXT_BUTTON_SIZES } from "@src/appV2/redesign/system/ui-components";

export interface TextButtonProps extends Omit<TextButtonBaseProps, "LinkComponent"> {
  children?: ReactNode;
}

export function TextButton(props: TextButtonProps) {
  return <TextButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
